import { createUseStyles } from 'react-jss';
export default createUseStyles(theme => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        minHeight: 48,
        whiteSpace: 'nowrap',
        padding: '10px 0 10px 15px',
        listStyleType: 'none',
        color: theme.palette.grey[12],
        cursor: 'pointer',
        backgroundColor: 'white',
        '&:hover': {
            backgroundColor: theme.palette.background,
            color: theme.palette.primary.regular
        }
    },
    active: { color: theme.palette.primary.regular }
}));
//# sourceMappingURL=styles.js.map